<template>
    <split-pane :defaultPercent="20">
      <div class="mw-split-left" slot="paneL">
        <div class="mw-panel-y mw-panel__tree">
          <div class="mw-toolbar">
            <mw-button @click="createNode(currentNode)">新建
            </mw-button>
            <mw-button @click="removeNode(currentNode)">删除
            </mw-button>
            <mw-button @click="showData">data
            </mw-button>
            <el-dropdown trigger="hover" @command="handleMoreCommand">
              <el-button class="el-dropdown-link">
                更多<i class="el-icon-caret-bottom el-icon--right"></i>
              </el-button>
              <el-dropdown-menu class="mw-toolbar-dropdown" slot="dropdown">
                <el-dropdown-item command="import" >导入</el-dropdown-item>
                <el-dropdown-item command="export">导出</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="mw-toolbar__body mw-app__edit" ref="treeContainer">
            <mw-tree :treeData="treeData" :async="false" :multiple="false" :contextMenuItem="treeContextMenu"
                    :expandedFirst="false" :autoLoad="true" :selectNode="selectNodeId"
                    @changed="treeClick" @move="dragend" ref="mwTree" ></mw-tree>
          </div>
        </div>
        <mw-dialog ref="dataDialog" size="large_large" title="导航树数据">
          <div class="mw-toolbar__body">
            <pre>{{treeListData}}
            </pre>
          </div>
        </mw-dialog>
        <mw-dialog ref="impDialog" title="导入导航菜单" @opened="showUpload" size="mini_small" :footerButton="impBtton">
          <div class="mw-dialog_body" style="margin-top:20px;">
            <el-form label-width="100px"  >
              <el-col :span="24">
                <el-form-item label="上传文件:">
                   <el-button ref="uploader">上传文件</el-button>
                   <div class="el-upload__tip">只能上传.xml文件</div>
                </el-form-item>
              </el-col>
            </el-form>
          </div>
        </mw-dialog>
      </div>
      <div class="mw-split-right" slot="paneR">
        <navigatorForm v-if="!!currentNode" :node="currentNode" :appId="appId"
                      @afterSave="afterSave"></navigatorForm>
      </div>
    </split-pane>
</template>

<script>
    import navigatorForm from './navigator_form';
    export default {
        components:{navigatorForm},
        data(){
          let me=this;
          let appId = '';
          if(me.$route){
            appId = me.$route.params.appId;
          }else if(me.params && me.params.appId){
            appId = me.params.appId;
          }
          // let sysId = me.$route.params.sysId;
          return {
            appId,
            treeData:[],
            currentNode:"",
            treeContextMenu:[],
            rightMenu:[],
            treeListData: null,
            selectNodeId:"",
            importAction:'/api/app/impAppNavigatorTreeComp',
            impBtton:[ {
              label: "取消",
              func:this.impCancel,
              type: "default"
            }],
           isFirstOpen:true
          }
        },
        props: {
          params: Object
        },
        mounted:function(){
            let me=this;
            me.treeContextMenu=[{
              name: "新建",
              icon: 'fa fa-plus',
              label: '新建',
              func: function (selectData, selectParent, item, a) {
                me.createNode(selectData);
              }
            },{
              name: "复制",
              icon: 'fa fa-copy',
              label: '复制',
              func: function(selectData, selectParent, item, a) {
                me.copyNode(selectData);
              }
            },{
              name: "删除",
              icon: 'fa fa-remove',
              label: '删除',
              func: function (selectData, selectParent, curBtn, item) {
                me.removeNode(selectData);
              }
            },{
              name: "导入",
              icon: 'fa x-icon-upload',
              label: '导入',
              func: function (selectData, selectParent, curBtn, item) {
                me.mwRef('impDialog').show();
              }
            },{
              name: "导出",
              icon: 'fa x-icon-download',
              label: '导出',
              func: function (selectData, selectParent, curBtn, item) {
                me.exportNode(selectData);
              }
            }];
            let contextMenu=PF.contextMenu({
              el:me.$refs.treeContainer,
              target:'.mw-tree-no-search__body',
              items:[{
                text:"新建",
                icon:"fa fa-new",
                handler:function(){
                  me.createRoot();
                }
              }]
            });
            me.$on("hook:destroyed",()=>{contextMenu.destroy()});
            me.loadTreeData();
        },
        methods:{
          showUpload(){
          if(this.isFirstOpen){
            this.initUploader();
            this.isFirstOpen=false;
          }
        },
        initUploader(){
            let me=this;
            let cfg={
              buttonId:me.mwRef('uploader').$el,
              maxSize:500,
              action:me.importAction,
              accept:"xml"
            }
            let fn={
              filesAdded:function(up){
              },
              fileUploaded(up, file,resp){
                me.importSuccessCallback(resp,file,up);
              }
            }
            PF.initPupload(cfg,fn,function(up){
              me.uploader=up;
              up.bind('FilesAdded', function(up, files) {
                up.setOption("multipart_params",{appId:me.appId,selNodeId:me.selectNodeId});
                up.start();
              });
            });
          },
          dragend(e, data){
            let me = this;
            let params = {};
            params.appId = me.appId;
            params.nodeId = data.node.id;
            params.position = data.position;
            params.oPosition = data.old_position;
            params.parentId = data.parent;
            params.oParentId = data.old_parent;
            me.mwApi.app.dragNavigatorTreeNode(params).then(res=>{
              if (res.result) {
                me.treeData = res.result;
                setTimeout(() => {
                  const tree=me.$refs.mwTree;
                  tree.refreshTreeData(me.treeData);
                  tree.setSelectNode(data.node.id);
                });
                me.$parent.$emit('updateTreeCount', {
                  id: 'navigator_tree',
                  length: me.treeData.length
                });
              }
            });
          },
          impCancel(){
          this.mwRef('impDialog').hide();
          },
          treeClick(node){
            if (!node.icon) node.icon = '';
            if (!node.bgColor) node.bgColor = '';
            if (!node.authorityForm) node.authorityForm = [];
            this.currentNode=node;
            if (!node.children || (node.children && node.children.length < 1)) {
              delete this.currentNode.children;
            }
          },
          loadTreeData(selectedNode){
            let me=this;
            me.mwApi.app.getNavigatorTree({appId:this.appId}).then(res=>{
              if (res.result && res.result.length > 0) {
                me.currentNode = !selectedNode ? res.result[0] : selectedNode;
                me.selectNodeId = me.currentNode.id;
              }
              me.treeData=res.result || [];
              me.$parent.$emit('updateTreeCount', {
                id: 'navigator_tree',
                length: me.treeData.length
              });
            });
          },
          refreshTree:function(){

          },
          createNode(selectData){
            let me = this;
            if (!selectData || !selectData.id) {
              me.createRoot();
            } else {
                const tree=me.$refs.mwTree;
                const children = tree.getNode(selectData.id).children || [];
                let node = {text:"新链接", parentId:selectData.id, sn:children.length};
                me.currentNode = node;
            }
          },
          copyNode(selectData){
            let me = this;
            if (!selectData || !selectData.id) return false;
            let tree = me.$refs.mwTree;
            me.mwApi.app.copyNavigatorTree(this.appId, selectData.id).then(res=>{
              if (res.errMsg) {
                me.mwMsg("复制失败:"+res.errMsg);
              } else {
                me.treeData=res.result || [];
                tree.refreshTreeData(me.treeData);
                me.mwMsg("复制成功");
                me.$parent.$emit('updateTreeCount', {
                  id: 'navigator_tree',
                  length: me.treeData.length
                });
              }
            });
          },
          removeNode(selectData){
            let me = this;
            PF.confirm($lang('删除此节点后将无法恢复,确定要继续吗？'), $lang('提示'), {type: 'warning'}).then(() => {
                let tree = me.$refs.mwTree;
                me.mwApi.app.removeNavigatorTree(this.appId, selectData.id).then(res=>{
                  if (res.errMsg) {
                    me.mwMsg("删除失败:" + res.errMsg);
                  } else {
                    me.treeData=res.result || [];
                    tree.refreshTreeData(me.treeData);
                    me.mwMsg("删除成功");
                    me.$parent.$emit('updateTreeCount', {
                      id: 'navigator_tree',
                      length: me.treeData.length
                    });
                  }
                });
            });
          },
          createRoot(){
            let me=this;
            const sn = me.treeData.length;
            let node = {text:"新链接",id:'',sn:sn,category: 'link',name: '',exp:'',disable: '1',linkType: 'view',style: 'tree',unit:'1',dept:'0',targetId: '',parentId: '',nav: '1',target: '',way: '1'};
            me.currentNode=node;
            //me.$refs.mwTree.createNode('#',node,'last');
          },
          showData(){
            var me = this;
            let data = me.$refs.mwTree.getTreeData();
            me.treeListData = data;
            me.mwRef('dataDialog').show();
          },
          afterSave(data,isNew) {
            let me=this;
            let tree=me.$refs.mwTree;
            if(isNew) {
              if (data.parentId) {
                me.treeData = me.fixedTreeNode(me.treeData, data.parentId, data);
                tree.createNode(data.parentId, data, 'last');
                // tree.refreshTreeData(me.treeData);
                tree.openNode(data.parentId);
              } else {
                let node=tree.createNode('#', data, 'last');
                me.treeData.push(data);
                // tree.refreshTreeData(me.treeData);
              }
              me.currentNode = data;
              me.loadTreeData(me.currentNode);
              me.$parent.$emit('updateTreeCount', {
                id: 'navigator_tree',
                length: me.treeData.length
              });
            }else{
              // tree.setNodeText(me.currentNode.id,data.name);
              Object.assign(me.currentNode, data);
              me.loadTreeData(me.currentNode);
            }
          },
          fixedTreeNode(treedata, parentId, pushInfo) {
            let me = this;
            let result = treedata;
            for (let i = 0; i < result.length; i++) {
              let isBreak = false;
              if (result[i].id == parentId) {
                result[i].children = result[i].children || [];
                result[i].children.push(pushInfo);
                break;
              } else if (result[i].children && result[i].children.length > 0) {
                result[i].children = me.fixedTreeNode(result[i].children, parentId, pushInfo);
              }
            }
            return result;
          },
          import(){
            let me=this;
            me.mwRef("importData").submit();
          },
          handleMoreCommand(command){
            let me=this;
            if(command === 'import'){
              this.mwRef('impDialog').show();
            }
            if(command === 'export'){
              me.exportNode(me.currentNode);
            }
          },
          importSuccessCallback(response, file, fileList) {
            if(response.result){
              this.loadTreeData();
              this.mwRef('impDialog').hide();
            }
          },
          getAllChildNodes(ids,pid,tree){
            ids.push(pid);
            let children=tree.getNode(pid).children || [];
            if(children.length>0){
              children.forEach((val) => {
                  this.getAllChildNodes(ids,val,tree);
              })
            }
            return ids;
          },
          exportNode(selectData){
            let ids=[];
            let tree=this.mwRef('mwTree');
            ids=this.getAllChildNodes(ids,selectData.id,tree)
            let par={appId:this.appId,ids:ids};
            this.mwUtil.downloadAttachment(this.mwUrl("/api/app/expAppNavigatorTreeComp"),{},false,PF.encode(par));
          }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/modules/index/views/appModule/navigator_tree/index.vue